import { useCustomerCompanyRetrieve } from "@boundless/bl-api-client/customer/services"
import {
  createFileRoute,
  linkOptions,
  Navigate,
  retainSearchParams,
} from "@tanstack/react-router"
import { useStore } from "zustand/react"

import { PendingComponent } from "@/components/error/PendingComponent"
import { store } from "@/lib/store"
import { getCurrentStepPath } from "@/lib/utils"

export const Route = createFileRoute("/_dashboard/resume")({
  search: {
    middlewares: [retainSearchParams(true)],
  },
  component: RouteComponent,
})

function RouteComponent() {
  const activeCompanyUuid = useStore(store, (state) => state.activeCompanyUuid)
  const {
    data: company,
    isPending,
    isFetching,
  } = useCustomerCompanyRetrieve(activeCompanyUuid ?? "", {
    query: {
      enabled: !!activeCompanyUuid,
      staleTime: 0,
    },
  })

  if (isPending || isFetching) {
    return <PendingComponent />
  }

  const continueTo = company
    ? getCurrentStepPath(
        company.currentStep,
        company.latestUnsubmittedApplicationUuid,
        company.latestSubmittedFundingNeedsUuid,
      )
    : linkOptions({ to: "/company/details" })
  return <Navigate {...continueTo} />
}
